document.addEventListener('DOMContentLoaded', () => {

  if (window.innerWidth <= 768) {
    return; // Disable slider on mobile
  }

  new Swiper('.festivities-slider', {
    slidesPerView: 4,
    spaceBetween: 12,
    loop: true,

    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },

    speed: 800,

    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    }
  });

});